import { Pill } from "PFComponents/pill";
import { Engagement } from "PFTypes";

export const EngagementRolesBadge = ({ engagement }: { engagement: Engagement }) => {
  const { roles_workflow_state_tally: { filled, exception, confirmed, booked } = {}, roles } = engagement;
  const filledCount = (filled || 0) + (exception || 0) + (confirmed || 0) + (booked || 0);
  const rolesCountText = `${filledCount || 0} / ${roles.length}`;

  return <Pill small text={rolesCountText} />;
};
